import React from 'react';
import { GridTableHeaders } from '../styles';

interface SurveyTableHeadersProps {
  fields: Array<{ caption: string }>;
}

const SurveyTableHeaders: React.FC<SurveyTableHeadersProps> = ({ fields }) => {
  return (
    <>
      <GridTableHeaders>Nombre</GridTableHeaders>
      <GridTableHeaders>E-mail</GridTableHeaders>
      {fields?.map((field, index) => (
        <GridTableHeaders key={`field-header-${index}`}>
          {field.caption}
        </GridTableHeaders>
      ))}
    </>
  );
};

export default SurveyTableHeaders;
